import { get, put } from 'utils/rxfetch'

export default () => ({
  getAdeKillswitch(companyId = '') {
    return get(`/ade/killswitch/?companyFilter=${companyId}`)
  },
  putAdeKillswitch(data, companyId = '') {
    return put(`/ade/killswitch/?companyFilter=${companyId}`, data)
  },
})
